<template>
    <header>
        <router-link :to="Links.Url(Links.Dashboard)">
            <figure>
                <img src="/assets/img/logo/logo.svg" alt="Rehberim Sensin" class="logo">
            </figure>
        </router-link>
        <div class="mobile-header-actions">
            <template v-if="userType == Enums.USER_TYPE.TEACHER || userType == Enums.USER_TYPE.INSTRUCTOR || isBuyPackage">
                <!--
                    Mobil özel ders hızlı erişimi.
                    Şimdilik manualLiveMeetings üzerinden manuel içerik gösteriliyor.
                    Backend hazır olduğunda liveMeetingOptions computed'ı gerçek aktif görüşme listesine bağlanabilir.
                -->
                <div v-if="hasLiveMeeting" class="mobile-live-meeting" :class="{ open: liveMeetingDropdownOpen }">
                    <button type="button"
                            class="mobile-header-icon-btn mobile-live-meeting-btn"
                            :title="hasMultipleLiveMeetings ? 'Aktif özel dersler' : 'Özel derse katıl'"
                            :aria-expanded="hasMultipleLiveMeetings ? liveMeetingDropdownOpen : false"
                            @click.stop="handleLiveMeetingClick">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="3" y="5" width="14" height="14" rx="3" stroke="currentColor" stroke-width="1.8" />
                            <path d="M17 10L21 7.5V16.5L17 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 9L12.5 12L8.5 15V9Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="mobile-live-pulse" aria-hidden="true"></span>
                        <span v-if="hasMultipleLiveMeetings" class="mobile-live-count">{{ liveMeetingOptions.length }}</span>
                    </button>

                    <div v-if="hasMultipleLiveMeetings && liveMeetingDropdownOpen" class="mobile-live-dropdown" @click.stop>
                        <div class="mobile-live-dropdown-head">
                            <div>
                                <strong>Aktif Özel Dersler</strong>
                                <span>Katılmak istediğiniz görüşmeyi seçin.</span>
                            </div>
                            <span class="mobile-live-total">{{ liveMeetingOptions.length }}</span>
                        </div>

                        <div class="mobile-live-list">
                            <button v-for="meeting in liveMeetingOptions"
                                    :key="meeting.id"
                                    type="button"
                                    class="mobile-live-item"
                                    @click="joinLiveMeeting(meeting)">
                                <span class="mobile-live-item-icon">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <rect x="3" y="5" width="14" height="14" rx="3" stroke="currentColor" stroke-width="1.8" />
                                        <path d="M17 10L21 7.5V16.5L17 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span class="mobile-live-item-copy">
                                    <strong>{{ meeting.teacherName }}</strong>
                                    <span>{{ meeting.lessonName }} · {{ meeting.dateText }} · {{ meeting.timeText }}</span>
                                </span>
                                <span class="mobile-live-join">
                                    Görüşmeye Katıl
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M5 12H19M13 6L19 12L13 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <router-link :to="Links.Url(Links.User.Message)"
                             class="mobile-header-icon-btn"
                             v-if="user.userType == Enums.USER_TYPE.STUDENT || user.userType == Enums.USER_TYPE.TEACHER || user.userType == Enums.USER_TYPE.INSTRUCTOR">
                    <span class="mobile-header-badge" v-if="isNewMessage">
                        {{ messageCount > 9 ? "+9" : messageCount }}
                    </span>

                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
                              stroke="currentColor"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                    </svg>
                </router-link>
            </template>

            <router-link :to="Links.Url(Links.User.Notification)" class="mobile-header-icon-btn">
                <span class="mobile-header-badge" v-if="isNewNotification">
                    {{ notificationCount > 9 ? "+9" : notificationCount }}
                </span>

                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                    <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                </svg>
            </router-link>
            <router-link :to="Links.Url(Links.User.Profile)"
                         class="mobile-header-icon-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-round-icon lucide-user-round"><circle cx="12" cy="8" r="5" /><path d="M20 21a8 8 0 0 0-16 0" /></svg>
            </router-link>

            <a href="javascript:void(0)" @click="logout" class="mobile-header-icon-btn logout">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                    <path d="M16 17L21 12L16 7"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                    <path d="M21 12H9"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                </svg>
            </a>
        </div>
    </header>
    <slot></slot>
    <!--<div class="d-flex justify-content-between">
        <div class="user-name m-3 d-flex w-100" v-if="info">
            <h3 class="fs-5 flex-fill">Merhaba, <span class="name">{{ C.Str(user.fullName) }}</span></h3>
            <h6 class="fs-6 good-day">{{ greetingMessage }}</h6>
        </div>
    </div>-->
    <template v-if="isActiveMeeting">
        <AgoraMeeting v-model:state="openActiveMeeting" :detail="list.appointment.selected" />
    </template>
</template>
<script>
    import { reactive, toRefs, computed, nextTick, onMounted, onBeforeUnmount } from "vue";
    import { useStore } from "vuex";
    import { useRouter } from "vue-router";

    import { Constants } from "@/helpers/constants";
    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C, D, J, Text } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import AgoraMeeting from "@/components/AgoraMeeting.vue"

    import { UserService } from "@/services/api/user";
    import { StoreUser, StoreAppointment, StoreMessage, StoreNotification } from "@/store/constants";

    export default {
        components: {
            AgoraMeeting
        },
        mounted() { this.get(); },
        unmounted() { this.bus.leave(); },
        setup() {
            const store = useStore();
            const router = useRouter();

            const e = reactive({
                bus: appData.eventBus([Constants.Key.LeftSidebarStatus, Constants.Key.MeetingStatus]),
                leftSidebarStatus: {
                    get: computed(() => { return e.bus.get(Constants.Key.LeftSidebarStatus); }),
                },

                get() {
                    appData.bus.on(e.bus, (event) => {
                        if (event.key == Constants.Key.MeetingStatus) {
                            if (C.Bool(event.value)) {
                                if (e.hasMultipleLiveMeetings) {
                                    e.liveMeetingDropdownOpen = true;
                                }
                                else if (e.liveMeetingOptions.length === 1) {
                                    e.joinLiveMeeting(e.liveMeetingOptions[0]);
                                }
                                e.bus.set(Constants.Key.MeetingStatus, false);
                            }
                        }
                    });

                    const loadAppointment = () => {
                        e.currentHour = D.ServerNow().getHours();
                        if (
                            e.userType == Enums.USER_TYPE.TEACHER
                            || e.userType == Enums.USER_TYPE.INSTRUCTOR
                            || e.isBuyPackage) {
                            e.list.appointment.load(() => { });
                        }
                    };
                    loadAppointment();
                    setInterval(() => { loadAppointment(); }, 60000);
                },
                user: computed(() => { return store.getters[StoreUser.get]; }),
                userType: computed(() => {
                    return C.Int(e.user.userType);
                }),
                isBuyPackage: computed(() => {
                    return C.Bool(e.user.isBuyPackage);
                }),
                currentHour: D.ServerNow().getHours(),
                greetingMessage: computed(() => {
                    if (e.currentHour >= 5 && e.currentHour < 12) {
                        return 'Günaydın';
                    }
                    else if (e.currentHour >= 12 && e.currentHour < 18) {
                        return 'İyi Günler';
                    }
                    else {
                        return 'İyi Akşamlar';
                    }
                }),
                messageCount: computed(() => {
                    const isStudent = e.userType == Enums.USER_TYPE.STUDENT;
                    return C.Int(store.getters[StoreMessage.getCountUnReaded](isStudent));
                }),
                notificationCount: computed(() => {
                    return C.Int(store.getters[StoreNotification.getCountUnReaded]);
                }),
                liveMeetingDropdownOpen: false,
                liveMeetingOptions: computed(() => {
                    return e.list.appointment.getActives;
                }),
                hasLiveMeeting: computed(() => e.liveMeetingOptions.length > 0),
                hasMultipleLiveMeetings: computed(() => e.liveMeetingOptions.length > 1),
                handleLiveMeetingClick() {
                    if (e.hasMultipleLiveMeetings) {
                        e.liveMeetingDropdownOpen = !e.liveMeetingDropdownOpen;
                        return;
                    }
                    if (e.liveMeetingOptions.length === 1) {
                        e.joinLiveMeeting(e.liveMeetingOptions[0]);
                    }
                },
                joinLiveMeeting(meeting) {
                    e.liveMeetingDropdownOpen = false;

                    if (!meeting) {
                        return;
                    }

                    e.list.appointment.selected = meeting;

                    if (meeting.meetingServer == Enums.MEETING_SERVER.AGORA) {
                        //if (!appData.isMobile) {
                        //    // yeni sekmede aç
                        //    const url = router.resolve({
                        //        name: "agoraMeeting",
                        //        params: { id: meeting.id }
                        //    }).href;
                        //    window.open(url, "_blank", "noopener,noreferrer");
                        //    return;
                        //}
                        nextTick(() => {
                            e.openActiveMeeting = true;
                        });
                        return;
                    }
                    if (!Text.IsEmpty(meeting.meetingLink)) {
                        window.open(meeting.meetingLink, "_blank", "noopener,noreferrer");
                    }
                },
                closeLiveMeetingDropdown() {
                    e.liveMeetingDropdownOpen = false;
                },
                openActiveMeeting: false,
                isActiveMeeting: computed(() => {
                    return e.list.appointment.selected != null;
                }),
                isNewMessage: computed(() => {
                    return e.messageCount > 0;
                }),
                isNewNotification: computed(() => {
                    return e.notificationCount > 0;
                }),
                logout() {
                    UserService.Logout(true);
                },
                list: {
                    appointment: {
                        selected: null,
                        load(callback) {
                            nextTick(() => {
                                Web.Area((wait) => {
                                    store.dispatch(StoreAppointment.loadList, {
                                        wait, callback: () => { callback(); },
                                        userType: e.userType
                                    });
                                }, appData.fn.main());
                            });
                        },
                        get: computed(() => {
                            var l = J.Clone(store.getters[StoreAppointment.getList]);
                            l.forEach(r => {
                                r.dayDate = C.Date(r.dayDate);
                            });
                            l.sort((a, b) => {
                                if (a.dayDate >= b.dayDate) { return -1; }
                                return 1;
                            });
                            return l;
                        }),
                        getActives: computed(() => {
                            const l = e.list.appointment.get;
                            const now = D.ServerNow();

                            if (e.user.userType == Enums.USER_TYPE.INSTRUCTOR) {
                                const items = l.filter(r => C.Int(r.meeting.id) > 0
                                    && (r.meeting.server == Enums.MEETING_SERVER.AGORA || !Text.IsEmpty(r.link))
                                    && r.meeting.meetingState == Enums.MEETING_STATE.PENDING
                                    && D.DateAdd(Enums.DATE.MINUTE, -5, C.Date(r.dayDate)) <= now
                                    && now <= D.AddHour(1, C.Date(r.dayDate))
                                );

                                items.forEach(x => {
                                    if (x.meeting) {
                                        x.meetingId = x.meeting.id;
                                        x.meetingServer = x.meeting.server;
                                        x.meetingCode = x.meeting.code;
                                        x.meetingLink = x.meeting.link;
                                        x.meetingState = x.meeting.meetingState;
                                    }
                                });

                                return items;
                            }

                            return l.filter(r => C.Int(r.meetingId) > 0
                                && (r.meetingServer == Enums.MEETING_SERVER.AGORA || !Text.IsEmpty(r.meetingLink))
                                && r.meetingState == Enums.MEETING_STATE.PENDING
                                && D.DateAdd(Enums.DATE.MINUTE, -5, C.Date(r.dayDate)) <= now
                                && now <= D.AddHour(1, C.Date(r.dayDate))
                            );
                        }),
                    }
                }
            });

            onMounted(() => {
                document.addEventListener("click", e.closeLiveMeetingDropdown);
            });

            onBeforeUnmount(() => {
                document.removeEventListener("click", e.closeLiveMeetingDropdown);
            });

            return { ...toRefs(e) };
        },
    };
</script>

<style scoped>
    .mobile-live-meeting {
        position: relative;
        display: flex;
        align-items: center;
    }

    .mobile-live-meeting-btn {
        position: relative;
        color: #7132df !important;
        background: #fff !important;
    }

        .mobile-live-meeting-btn:active,
        .mobile-live-meeting.open .mobile-live-meeting-btn {
            color: #6328e4 !important;
            background: #f6f1ff !important;
        }

    .mobile-live-pulse {
        position: absolute;
        top: 7px;
        right: 7px;
        width: 6px;
        height: 6px;
        background: #22c55e;
        border: 2px solid #fff;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(34, 197, 94, .26);
        animation: mobileLivePulse 1.8s infinite;
    }

    .mobile-live-count {
        position: absolute;
        top: -5px;
        right: -5px;
        display: grid;
        place-items: center;
        min-width: 18px;
        height: 18px;
        padding: 0 4px;
        color: #fff;
        background: #6328e4;
        border: 2px solid #fff;
        border-radius: 999px;
        font-size: 9px;
        font-weight: 800;
        line-height: 1;
    }

    .mobile-live-dropdown {
        position: fixed;
        top: 76px;
        right: 10px;
        left: 10px;
        z-index: 1200;
        max-height: min(420px, calc(100dvh - 92px));
        overflow: hidden;
        background: #fff;
        border: 1px solid #e6dcf6;
        border-radius: 15px;
        box-shadow: 0 18px 42px rgba(48, 31, 76, .17);
    }

    .mobile-live-dropdown-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 13px 14px 11px;
        background: linear-gradient(135deg, #fbf9ff 0%, #f4edff 100%);
        border-bottom: 1px solid #eee7f8;
    }

        .mobile-live-dropdown-head > div {
            display: flex;
            min-width: 0;
            flex-direction: column;
            gap: 2px;
        }

        .mobile-live-dropdown-head strong {
            color: #282331;
            font-size: 13px;
            font-weight: 750;
        }

        .mobile-live-dropdown-head > div > span {
            color: #8d8499;
            font-size: 10px;
        }

    .mobile-live-total {
        display: grid;
        flex: 0 0 28px;
        place-items: center;
        width: 28px;
        height: 28px;
        color: #6328e4;
        background: #ece2ff;
        border-radius: 50%;
        font-size: 11px;
        font-weight: 800;
    }

    .mobile-live-list {
        max-height: calc(min(420px, 100dvh - 92px) - 62px);
        padding: 0px 7px;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .mobile-live-item {
        display: grid;
        grid-template-columns: 38px minmax(0, 1fr) auto;
        align-items: center;
        gap: 9px;
        width: 100%;
        min-width: 0;
        padding: 10px 9px;
        color: inherit;
        text-align: left;
        background: transparent;
        border: 0;
        border-radius: 10px;
    }

        .mobile-live-item + .mobile-live-item {
            border-top: 1px solid #f0ebf6;
            border-radius: 0 0 10px 10px;
        }

        .mobile-live-item:active {
            background: #faf7ff;
        }

    .mobile-live-item-icon {
        display: grid;
        place-items: center;
        width: 38px;
        height: 38px;
        color: #6328e4;
        background: #f1eaff;
        border: 1px solid #e2d4ff;
        border-radius: 10px;
    }

    .mobile-live-item-copy {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 2px;
    }

        .mobile-live-item-copy strong {
            overflow: hidden;
            color: #2a2532;
            font-size: 12px;
            font-weight: 700;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .mobile-live-item-copy span {
            overflow: hidden;
            color: #8a8194;
            font-size: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

    .mobile-live-join {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        color: #6328e4;
        font-size: 10px;
        font-weight: 750;
        white-space: nowrap;
    }

    @keyframes mobileLivePulse {
        0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, .26);}
        70% { box-shadow: 0 0 0 5px rgba(34, 197, 94, 0); }
        100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
    }

    @media (max-width: 480px) {
        .mobile-live-dropdown {
            top: 68px;
            right: 8px;
            left: 8px;
            border-radius: 13px;
        }

        .mobile-live-dropdown-head {
            padding: 10px 12px;
        }

        .mobile-live-item {
            grid-template-columns: 36px minmax(0, 1fr) auto;
            gap: 8px;
            padding: 9px 8px;
        }

        .mobile-live-item-icon {
            width: 36px;
            height: 36px;
        }

        .mobile-live-join {
            grid-column: 3;
            justify-self: end;
            margin-top: 0;
            font-size: 9px;
        }
    }
</style>